import styled, { keyframes } from 'styled-components'
import { Link } from 'react-router-dom'

const heartbeat = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
`

export const Container = styled.footer`
  background: ${({ theme }) => theme.colors.footerGradient};
  color: ${({ theme }) => theme.colors.onPrimary};
  margin-top: auto;
  width: 100%;
`

export const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 20px 40px;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 40px;

  @media (max-width: 960px) {
    grid-template-columns: 1fr 1fr;
    gap: 30px;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`

export const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  h3 {
    font-size: 1.3rem;
    font-weight: 700;
    margin-bottom: 5px;
    color: white;

    @media (max-width: 600px) {
      font-size: 1.2rem;
    }
  }

  h4 {
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 5px;
    color: white;
    opacity: 0.95;

    @media (max-width: 600px) {
      font-size: 1rem;
    }
  }

  p {
    line-height: 1.6;
    opacity: 0.9;
    font-size: 0.95rem;
    max-width: 400px;
    color: white;

    @media (max-width: 600px) {
      font-size: 0.9rem;
    }
  }
`

export const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const FooterLink = styled(Link)`
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  width: fit-content;
  position: relative;
  padding: 4px 0;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background: white;
    transition: width 0.3s ease;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.onPrimary};
    transform: translateX(5px);

    &::after {
      width: 100%;
    }
  }

  @media (max-width: 600px) {
    font-size: 0.9rem;
  }
`

export const SocialLinks = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 10px;

  a {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1.2rem;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);

    &:hover {
      background: ${({ theme }) => theme.colors.onPrimary};
      color: ${({ theme }) => theme.colors.primary};
      transform: translateY(-3px) scale(1.1);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    }

    &:active {
      transform: translateY(-1px) scale(1.05);
    }
  }
`

export const Copyright = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding: 25px 20px;

  .copyright-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;

    @media (max-width: 600px) {
      flex-direction: column;
      text-align: center;
      gap: 10px;
    }

    p {
      font-size: 0.9rem;
      opacity: 0.9;
      margin: 0;
      color: white;

      @media (max-width: 600px) {
        font-size: 0.85rem;
      }
    }

    .made-with {
      display: flex;
      align-items: center;
      gap: 5px;

      .heart {
        display: inline-block;
        animation: ${heartbeat} 1.5s ease-in-out infinite;
        color: #ff6b6b;
      }
    }
  }
`
